"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ControlledContactTextField = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var react_component_library_1 = require("@esub-engineering/react-component-library");
var react_hook_form_1 = require("react-hook-form");
exports.ControlledContactTextField = react_1.default.memo(function (_a) {
    var label = _a.label, control = _a.control, limitTags = _a.limitTags, setSearchCriteria = _a.setSearchCriteria, _b = _a.options, options = _b === void 0 ? [] : _b, _c = _a.isEmail, isEmail = _c === void 0 ? false : _c, rest = __rest(_a, ["label", "control", "limitTags", "setSearchCriteria", "options", "isEmail"]);
    var _d = (0, react_hook_form_1.useController)({
        name: rest.name,
        control: control,
    }), _e = _d.field, ref = _e.ref, onChange = _e.onChange, value = _e.value, inputProps = __rest(_e, ["ref", "onChange", "value"]), _f = _d.fieldState, isInvalid = _f.invalid, errors = _f.error;
    var checkErrorMessage = function () {
        if (isInvalid) {
            // @ts-ignore
            if (errors && errors.length > 0) {
                // @ts-ignore
                return errors.filter(function (error) {
                    return Boolean(error.message);
                })[0].message;
            }
            // @ts-ignore
            return errors.message;
        }
        return undefined;
    };
    var validationProps = {
        error: isInvalid,
        helperText: checkErrorMessage(),
    };
    return ((0, jsx_runtime_1.jsx)(react_component_library_1.ContactTextField, __assign({}, rest, inputProps, validationProps, { onChange: onChange, label: label, limitTags: limitTags, value: value, setSearchCriteria: setSearchCriteria, options: options, isEmail: isEmail })));
});
